module.exports = __webpack_public_path__ + "fonts/mui.8820b7f6.ttf";